<div class="flex flex-col">
  <label class="block text-xs font-semibold text-[#25282D] mb-1">
    {{ label }}
    @if (showAsterisk) {
    <span class="text-orange-500  text-xs font-semibold">*</span>
    }
  </label>
  <div
    class="border border-[#DBE0E6] bg-[#F8F8FE] rounded-md p-[8px] flex space-x-4 items-center w-full"
  >
    <!-- Dynamic Radio Options -->
    @for (option of options; track option.id) {
    <label class="flex items-center space-x-2 cursor-pointer">
      <input
        type="radio"
        [name]="name"
        [value]="option.id"
        [checked]="selectedValue === option.id"
        (change)="onSelectionChange(option.id)"
        class="hidden"
      />
      <span
        class="w-4 h-4 border border-[#723CEB] rounded-full flex items-center justify-center"
      >
        @if (selectedValue === option.id) {
        <span class="w-4 h-4 bg-[#723CEB] rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16px"
            viewBox="0 -960 960 960"
            width="16px"
            fill="#FFFFFF"
          >
            <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
          </svg>
        </span>
        }
      </span>
      <span class="text-xs text-[#96A0B5]">{{ option.label }}</span>
    </label>
    }
  </div>
</div>
